"use client";
import { jsx } from "react/jsx-runtime";
import { component } from "@gnist/component-utils";
import { tokens } from "@gnist/themes/tokens.css.js";
import { spinnerRecipe } from "./spinner.css.js";
const SpinnerComponent = ({ textDescription, ...props }) => {
  const borderColor = `${tokens.color[props.backgroundColor ?? "on-disabled"]}`;
  return jsx("div", { ...props, "aria-label": textDescription, style: {
    height: props.diameter,
    width: props.diameter,
    borderColor: `${borderColor} ${borderColor} transparent ${borderColor}`
  } });
};
const Spinner = component("Spinner", spinnerRecipe, SpinnerComponent);
export {
  Spinner
};
